var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fullwidth"},[_c('UHFPDSensorOverview'),_c('hr'),_c('ElectricalPDSensorsOverview'),_c('hr'),_c('OtherPDSensorsOverview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }